import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { ReportMenuComponent } from './components/report-menu/report-menu.component';
import { ReportingComponent } from './components/reporting/reporting.component';
import { ReportEditDialogComponent } from './components/report-edit-dialog/report-edit-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GridModule } from '@progress/kendo-angular-grid';
import { ReportingService } from './services/reporting.service';

@NgModule({
    declarations: [ReportMenuComponent, ReportingComponent, ReportEditDialogComponent],
    imports: [
        CommonModule,
        ReportsRoutingModule,
        SharedModule,
        DragDropModule,
        GridModule,
        ThirdPartyModule,
    ],
    providers: [ReportMenuComponent, ReportingService],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ReportModule {}
